import { LoadingSuspense } from "@/components/loading/Loading.tsx";
import { useBreakpointSizeAttribute } from "@/modules/main/breakPoints.ts";
import type { BaseProps } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";

export function LayoutContent({ children, ...props }: { children?: ReactNode } & BaseProps) {
    const ref = useBreakpointSizeAttribute();

    return (
        <main ref={ref} {...props}>
            <LoadingSuspense>{children}</LoadingSuspense>
        </main>
    );
}
